import React from 'react'
import { MessageSquare } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props { count?: number }

const ClubForumSkeleton: React.FC<Props> = ({ count = 3 }) => {
  return (
    <div className="space-y-6 animate-pulse">
      <div className={cn(
        "flex items-center justify-between pb-4 border-b",
        "border-dark-300"
      )}>
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-dark-300 rounded-full" />
          <div className="h-6 w-48 bg-dark-300 rounded-lg" />
        </div>
        <div className="h-10 w-28 bg-dark-300 rounded-lg" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: count }).map((_, idx) => (
          <div key={idx} className="p-6 rounded-xl border border-dark-300 bg-dark-200">
            <div className="flex items-center justify-center flex-col">
              <div className="w-12 h-12 rounded-full bg-dark-300 mb-3" />
              <div className="h-5 w-32 bg-dark-300 rounded mb-2" />
              <div className="h-4 w-48 bg-dark-300 rounded" />
              <div className="flex items-center space-x-4 mt-4">
                <div className="h-4 w-20 bg-dark-300 rounded" />
                <div className="h-4 w-20 bg-dark-300 rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center py-12 rounded-xl border border-dark-400 bg-dark-300">
        <MessageSquare className="h-12 w-12 text-dark-800 mx-auto mb-4 opacity-50" />
        <div className="h-6 w-48 bg-dark-300 rounded mx-auto mb-2" />
        <div className="h-4 w-64 bg-dark-300 rounded mx-auto mb-6" />
        <div className="h-10 w-32 bg-dark-300 rounded-lg mx-auto" />
      </div>
    </div>
  )
}

export default ClubForumSkeleton
